import React, { useState } from "react";

import { Icon, Input } from "semantic-ui-react";
import { makeStyles } from "@mui/styles";

type SearchBoxInputProps = {
  id?: string;
  value: string;
  isLoading?: boolean;
  circular?: boolean;
  onChange: (value: string) => void;
  onDebouncedChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
  autoFocus?: boolean;
};

const useStyles = makeStyles(() => ({
  input: {
    "&.ui.input input": {
      borderRadius: "16px",
      border: "1px solid #EAEAEA",
      backgroundColor: "#FFFFFF",
      fontSize: "14px",
    },
    "&.ui.input input.circular": { borderRadius: "20px" },
    "& i.search": {
      color: "#9E9E9E",
    },
    "& i.search.circular": {
      background: "var(--primary-theme-color)",
    },
  },
}));

const SearchBoxInput: React.FC<SearchBoxInputProps> = (props) => {
  const classes = useStyles();

  const [typingTimeout, setTypingTimeout] = useState<any>(null);

  const handleChange = (newValue: string) => {
    props.onChange(newValue);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        props.onDebouncedChange(newValue);
      }, props.debounceMs || 800),
    );
  };

  return (
    <Input
      id={props.id}
      value={props.value}
      fluid
      className={`${classes.input} provider-input ${
        props.circular ? "circular" : ""
      }`}
      placeholder={props.placeholder || "ค้นหาที่อยู่"}
      autoFocus={props.autoFocus !== false}
      loading={props.isLoading}
      icon={
        props.value ? (
          <Icon name="close" link onClick={() => handleChange("")} />
        ) : props.circular ? (
          <Icon name="search" inverted circular link style={{ opacity: 1 }} />
        ) : (
          "search"
        )
      }
      size="large"
      onChange={(e) => {
        handleChange(e.target.value);
      }}
    />
  );
};

export default SearchBoxInput;
